


import { useEffect, useState } from 'react';
import { StudentService } from '@/lib/Student';
import { useQuery } from '@tanstack/react-query';

/**
 * Hook to get student verification status using StudentService.getVerificationStatus
 * 
 * @param userId - The ID of the student to check verification status for
 * @returns { status, loading, error, refetch }
 */
export function useStudentVerificationStatus(userId: string) {
  return useQuery({
    queryKey: ['student-verification-status', userId],
    queryFn: async () => {
      return await StudentService.getVerificationStatus();
    },
    select(data) {
      return data.verifications[0];
    },
    refetchOnWindowFocus: true,
    cacheTime: 60 * 60 * 1000
  });
}